import { APP_ROUTES } from 'constants/routes';

import React from 'react';
import Link from 'next/link';
import Title from 'features/layout/components/Cards/common/Title';
import { Icons } from '@studenten/ui-components';
import cityPlaceholder from '../../../../../public/assets/placeholders/placeholder-8.svg';

import Picture from '../common/Picture';

import {
  DetailsContainer,
  GroupContainer,
  InfoContainer,
  University,
  Colleges,
  StudentsContainer,
  Container,
  OnlyTitleCardContainer,
  TitleWrapper,
} from './CityCard.styled';
import type { Props } from './types';

export const CityCard = ({
  title,
  numberOfUniversities,
  numberOfHBO,
  photoURL,
  numberOfStudents,
  horizontal = false,
  slug,
  onlyTitle,
}: Props) => {
  if (onlyTitle) {
    return (
      <Link href={`${APP_ROUTES.CITIES}/${slug}`} passHref>
        <a>
          <OnlyTitleCardContainer>
            <Title maxLineCount={2} size={'1.6rem'}>
              {title}
            </Title>
          </OnlyTitleCardContainer>
        </a>
      </Link>
    );
  }

  return (
    <Link href={`${APP_ROUTES.CITIES}/${slug}`} passHref>
      <a>
        <Container horizontal={horizontal}>
          <Picture
            src={photoURL}
            height={horizontal ? '100px' : '90px'}
            width={horizontal ? '271px' : '100%'}
            alt={title}
            fallBackSRC={cityPlaceholder}
            loading="lazy"
          />
          <InfoContainer horizontal={horizontal}>
            <TitleWrapper>
              <Title maxLineCount={2}>{title}</Title>
            </TitleWrapper>
            <DetailsContainer horizontal={horizontal}>
              <GroupContainer horizontal={horizontal}>
                {!!numberOfHBO && (
                  <Colleges isUniversity={!!numberOfUniversities}>
                    {new Intl.NumberFormat('en-US', { style: 'decimal' }).format(numberOfHBO)} HBOs
                  </Colleges>
                )}
                {!!numberOfUniversities && (
                  <University>
                    {new Intl.NumberFormat('en-US', { style: 'decimal' }).format(
                      numberOfUniversities
                    )}{' '}
                    universities
                  </University>
                )}
              </GroupContainer>
              {!!numberOfStudents && (
                <StudentsContainer>
                  <Icons.AcademicHead /> <span>{numberOfStudents} students </span>
                </StudentsContainer>
              )}
            </DetailsContainer>
          </InfoContainer>
        </Container>
      </a>
    </Link>
  );
};
